<template>
    <v-card-title class="text-h4 font-weight-bold pa-0 primary-text-color mb-6 d-flex align-center"> {{ text }} </v-card-title>
</template>

<script setup lang="ts">
import { IFormTitle } from '../types';

defineProps<IFormTitle>();
</script>
